export const isUsingPwa = () => {
  return window.matchMedia("(display-mode: standalone)").matches;
};
